import React, { ChangeEvent, useEffect, useState } from "react";
/* AntD */
import { Button, Dropdown, Form, Input, Menu, message, Space, Tag, Upload } from "antd";
import { useForm } from "antd/lib/form/Form";
/* Components */
import { DynamicFields } from "./dynamicFields";
import IconByMimeType from "../../components/Utility/IconByMimeType";
import { AntdFormSelectField, Layout, AntdFormDragger, AntdFormCheckbox, AntdFormInputField } from "../../components";
/* Services and interfaces */
import { getDocumentS3Keys } from "../../services/documents";
import { UploadFile, UploadListType } from "antd/lib/upload/interface";
import { DocumentType, getDocumentTypes } from "../../services/documentTypes";
/* Utility */
import JSZip from "jszip";
import { v4 as uuidv4 } from "uuid";
import {
  S3Client,
  PutObjectCommand,
  PutObjectCommandInput,
} from "@aws-sdk/client-s3";
import {
  NotificationInterface,
  notify,
  operationError,
  operationInfo
} from "../../services/notification-wrapper";
import {
  uploadTranslations as upload,
  commonTranslations as common,
  getRequiredValidation,
  fileToBlob,
  toBase64,
  uploadTranslations,
  commonTranslations,
} from "../../helpers";
import { MailOutlined, PlusOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";

const DocumentUpload = () => {
  const [form] = useForm();
  const [changedFields, setChangedFields] = useState(null)
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [documentTypes, setDocumentTypes] = useState<DocumentType[]>([]);
  const [selectedDocType, setSelectedDocType] = useState<DocumentType>(null);
  const [formStructure, setFormStructure] = useState<any>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const [sendEmail, setSendEmail] = useState<boolean>(false);
  const [emailToAdd, setEmailToAdd] = useState<string>("");
  const [toList, setToList] = useState<string[]>([]);
  const [ccList, setCcList] = useState<string[]>([]);
  const [mailBody, setMailBody] = useState<string>("");

  useEffect(() => {
    getTipiDocumento();
  }, []);

  const getTipiDocumento = async () => {
    try {
      const responseTipiDoc = await getDocumentTypes({ limit: 10000, order_by: "label", sort_dir: "asc" });
      setDocumentTypes(responseTipiDoc.documentType);
    } catch (error) {
      console.log("Errore", error);
    }
  };

  const onDocumentTypeChange = (value) => {
    const docType = documentTypes.filter(
      (documentType) => documentType.id === value
    )[0];
    setSelectedDocType(docType)
    if (docType) {
      setToList(docType.emailPreviewJson?.to || []);
      setCcList(docType.emailPreviewJson?.cc || []);
      form.setFieldsValue({ object: docType.emailPreviewJson?.object })
      setMailBody(docType.emailPreviewJson?.body);
    }
    clearDynamicFields();
    setFormStructure(docType?.formStructure);
  };

  const uploadDocument = async (formValues) => {
    if (!fileList?.length) return;
    try {
      setIsSaving(true);
      const keys = await getDocumentS3Keys();

      const emailData = {
        to: toList,
        cc: ccList,
        body: mailBody,
        object: formValues.object
      }

      delete formValues.documentsList;
      delete formValues.object;
      const zip = new JSZip();

      /* Aggiunta documenti nel file zip */
      const mimeTypes = {};
      for (const document of fileList) {
        mimeTypes[document.name] = document.type;
        const base64 = await toBase64(await fileToBlob(document));
        zip.file(document.name, base64.split(",")[1], { base64: true });
      }

      if (formValues?.CIG) {
        formValues.CIG = formValues.CIG.split(" - ")[0];
      }

      /* Creazione JSON metadati */
      const jsonb64 = await toBase64(
        new Blob(
          [
            JSON.stringify({
              ...formValues,
              ...(formValues.sendEmail ? { emailData } : {}),
              Tipo_Evento: "clientUpload",
              sourceSystem: "PDG_CLIENT",
              mimeTypes,
              sessionUUID: keys.sessionUUID,
            }),
          ],
          { type: "application/json" }
        )
      );
      zip.file("metatadata.json", jsonb64.split(",")[1], { base64: true });

      zip.generateAsync({ type: "uint8array" }).then((content) => {
        const s3 = new S3Client({
          credentials: {
            accessKeyId: keys.id,
            secretAccessKey: keys.secret,
          },
          region: "eu-west-1",
        });

        const dataToUpload: PutObjectCommandInput = {
          Bucket: keys.bucketname,
          Key: `${new Date().getTime()}_document_upload_${uuidv4()}.zip`,
          Body: content,
          ContentType: "application/zip",
        };

        s3.send(new PutObjectCommand(dataToUpload))
          .then((res) => {
            notify(operationInfo({ descriptionKey: "uploadInfoDesc", messageKey: "uploadInfoMessage" }));
            resetForm();
          })
          .catch((err) => {
            notify(operationError());
          })
          .finally(() => {
            setIsSaving(false);
          });
      });
    } catch (error) {
      setIsSaving(false);
      notify(operationError());
    }
  };

  const resetForm = () => {
    form.resetFields();
    setFileList([]);
    setFormStructure(null);
    setSendEmail(false);
    setToList([]);
    setCcList([]);
    setMailBody(null);
    setSelectedDocType(null);
  };

  const clearDynamicFields = () => {
    form.setFieldsValue({
      CIG: undefined,
      Anno: undefined,
      Fornitore: undefined,
      ODL: undefined,
      Mese: undefined,
      businessUnit: undefined,
      applicationCode: undefined,
      ODA: undefined,
      formaContrattualeNominato: undefined
    });
  };
  const handleAddTo = (value: string) => {
    if (!value) return;
    !toList.includes(value) && setToList([...toList, value]);
    setEmailToAdd("");
  };

  const handleAddCc = (value: string) => {
    if (!value) return;
    !ccList.includes(value) && setCcList([...ccList, value]);
    setEmailToAdd("");
  };

  const handleRemoveTo = (email: string) => {
    setToList(toList.filter((item: string) => item !== email));
  };

  const handleRemoveCc = (email: string) => {
    setCcList(ccList.filter((item: string) => item !== email));
  };
  const emailOptions = (
    <Menu>
      <Menu.Item key="1">
        <a onClick={() => handleAddTo(emailToAdd)}>{commonTranslations.buttons.add} To</a>
      </Menu.Item>
      <Menu.Item key="2">
        <a onClick={() => handleAddCc(emailToAdd)}>{commonTranslations.buttons.add} CC</a>
      </Menu.Item>
    </Menu>
  );
  const allowedFiles = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "p7m"];
  return (
    <Layout
      title={upload.title}
      disableInsert={true}
      isSaving={isSaving}
      onSave={() => form.submit()}
    >
      <div className="row d-flex justify-content-center mx-3">
        <section className="col-sm-12 col-md-10 col-lg-8 p-3 section">
          <Form
            onFinish={uploadDocument}
            name="documentsForm"
            className="row px-2"
            form={form}
            onValuesChange={(changedValues) => setChangedFields(changedValues)}
          >
            <div className="px-3 w-100">
              <h4>{upload.sectionDatiDoc}</h4>
              <hr />
              <p>{common.formValidations.requiredInfo}</p>
            </div>
            <AntdFormSelectField
              name="documentType_id"
              label={upload.labels.documentType}
              placeholder={upload.placeholders.documentType}
              options={documentTypes.map((documentType) => ({
                name: documentType.label,
                value: documentType.id,
              }))}
              rules={getRequiredValidation("upload", "documentType")}
              onChange={onDocumentTypeChange}
              cols="col-12 mb-4"
              required
            />

            {formStructure && (
              <DynamicFields
                changedFields={changedFields}
                formRef={form}
                formStructure={formStructure}
                clearFields={clearDynamicFields}
              />
            )}

            {!!selectedDocType?.canSendEmail &&
              <div className="col-12">
                <AntdFormCheckbox
                  name='sendEmail'
                  label={commonTranslations.labels.canSendEmail}
                  onChange={el => setSendEmail(el.target.checked)}
                />
              </div>
            }

            {!!sendEmail && <div className="container">
              <div className="row mt-4 px-2 d-flex justify-content-center align-items-center flex-column">
                <div className="col-12">
                  {commonTranslations.labels.emailTemplateSectionTitle}
                </div>
                <div className="col-12 d-flex mb-2 justify-content-between align-items-center">
                  <Input
                    onChange={(val: ChangeEvent<HTMLInputElement>) => setEmailToAdd(val.target.value)}
                    value={emailToAdd}
                    placeholder={commonTranslations.placeholders.email}
                  />
                  <Dropdown
                    className="ml-2"
                    overlay={emailOptions}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <Space>
                        {commonTranslations.buttons.add} <PlusOutlined />
                      </Space>
                    </a>
                  </Dropdown>
                </div>
                {(!!toList.length || !!ccList.length) && <div className="col-12 mt-2">
                  {toList.length > 0 && (
                    <div className="d-flex mb-1 overflow-auto">
                      <p className="mr-2">To:</p>
                      {toList.map((email: string) => (
                        <Tag
                          key={email}
                          closable
                          onClose={() => handleRemoveTo(email)}
                          style={{ height: "24px" }}
                        >
                          <MailOutlined /> {email}
                        </Tag>
                      ))}
                    </div>
                  )}
                  {ccList.length > 0 && (
                    <div className="d-flex mb-1 overflow-auto">
                      <p className="mr-2">Cc: </p>
                      {ccList.map((email: string) => (
                        <Tag
                          key={email}
                          closable
                          onClose={() => handleRemoveCc(email)}
                          style={{ height: "24px" }}
                        >
                          <MailOutlined /> {email}
                        </Tag>
                      ))}
                    </div>
                  )}
                </div>}
                <AntdFormInputField
                  name="object"
                  label={commonTranslations.labels.emailObject}
                  placeholder={commonTranslations.placeholders.emailObject}
                  cols='col-12 mb-2'
                />
                <ReactQuill
                  theme="snow"
                  defaultValue={mailBody}
                  onChange={setMailBody}
                  placeholder={commonTranslations.placeholders.emailBody}
                  className='col-12 mb-2'
                />
              </div>
            </div>}



            <AntdFormDragger
              inputName="documentsList"
              label={upload.labels.documents}
              cols="col-12"
              showUploadList={true}
              uploadProps={{
                multiple: true,
                onRemove(removedFile) {
                  setFileList(
                    fileList.filter(
                      (element) => element.uid !== removedFile.uid
                    )
                  );
                },
                onChange: (changes) =>
                  !changes?.fileList?.length && setFileList([]),
                iconRender(file: UploadFile<any>, listType?: UploadListType) {
                  return <IconByMimeType mimeType={file.type} size={30} />;
                },
                beforeUpload(newFile, newFileList) {
                  if (
                    allowedFiles.indexOf(newFile.name.split(".").pop()) > -1
                  ) {
                    setFileList((fl) => [...fl, newFile]);
                    return;
                  } else {
                    const notifyWarnObj: NotificationInterface = {
                      type: "warning",
                      params: {
                        message: commonTranslations.notifications.warning,
                        description: uploadTranslations.validationMessages.typeError,
                        key: "unwantedFileTypesWarning"
                      },
                    };
                    notify(notifyWarnObj);
                  }
                }
              }}
              type="file"
              fileList={fileList}
              required
              rules={[
                {
                  message: uploadTranslations.validationMessages.documents + '. ' + uploadTranslations.validationMessages.typeError,
                  required: true,
                  validator: () =>
                    !fileList.length ? Promise.reject() : Promise.resolve(),
                },
              ]}
            />

            <div className="col-12 d-flex justify-content-end">
              <Button
                htmlType="button"
                className="mr-2"
                onClick={resetForm}
                disabled={isSaving}
              >
                {common.buttons.reset}
              </Button>
              <Button
                htmlType="submit"
                className="ml-2"
                type="primary"
                disabled={isSaving}
              >
                {common.buttons.save}
              </Button>
            </div>
          </Form>
        </section>
      </div>
    </Layout>
  );
};

export default DocumentUpload;
